module.exports = __webpack_public_path__ + "img/Stylized Sword-Ice.8d3c8959.png";